import { connect } from 'react-redux';

import { Counter, TextLine, ItemsList, RadioboxCell } from 'components/common/tableComponents/cellTemplates';

import PersonSidebarLink from './PersonSidebarLink';

import { setWorksheetListSelected } from 'actions/worksheetActions';
import { getWorksheetList, getUser } from 'actions/asyncActions';
import { hasEventsAccess } from 'helpers/worksheetHelpers';

const stateToProps = ({ table: { worksheet: { selected } }, ...state }) => ({
    data: getWorksheetList.selectData(state),
    user: getUser.selectData(state),
    selected,
    checkDisabled: props => !hasEventsAccess(props.user, props.data)
});

const dispatchToProps = {
    setSelected: setWorksheetListSelected
};

const WorksheetRadioboxCell = connect(stateToProps, dispatchToProps)(RadioboxCell);

const WorksheetTableTemplates = {
    checkbox:       WorksheetRadioboxCell,
    number:         Counter,
    text:           PersonSidebarLink,
    working:        ItemsList,
    documents:      ItemsList,
    partsInProject: ItemsList,
    education:      ItemsList
};

export default function getWorksheetTableTemplate(columnName) {
    return WorksheetTableTemplates[columnName] || TextLine;
}
